export default "__VITE_ASSET__DN$VYOzz__"